import React, { useEffect, useState, lazy } from 'react';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
const checkoutUrl = 'https://kit-tarot-listo.impultienda.ar/checkout/kit-tarot-listo';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 34,
    seconds: 39
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (v: number) => v.toString().padStart(2, '0');
  return <div className="max-w-2xl mx-auto relative z-10 px-4" data-id="element-116">
      <div className="text-center mb-16" data-id="element-117">
        <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight text-brand-petroleum tracking-tight" data-id="element-118">
          Tu próxima lectura puede ser la primera que realmente entiendas
        </h2>
        <p className="text-brand-medium-grey text-lg italic mb-12" data-id="element-119">
          No necesitas un don especial. Solo una guía clara.
        </p>
      </div>

      <div className="bg-white rounded-[40px] p-8 md:p-12 shadow-premium border border-brand-petroleum/5 text-center relative overflow-hidden mb-12" data-id="element-120">
        <div className="absolute top-0 left-0 w-full h-1.5 bg-brand-gold-warm" data-id="element-121"></div>

        <div className="relative mb-8 max-w-xs mx-auto" data-id="element-122">
          <img src="https://cdn.magicpatterns.com/uploads/1rNfsoSUmbsZhffYJr5H9X/MOCKUP_PNG.png" alt="Método Tarot Listo Mockup" className="w-full h-auto relative z-10 mockup-shadow" width="320" height="240" loading="lazy" data-id="element-123" />
        </div>

        <div className="text-center mb-6" data-id="element-124">
          <div className="flex items-center justify-center gap-5 md:gap-8 mb-5" data-id="element-125">
            <div className="text-center" data-id="element-126">
              <span className="text-3xl md:text-4xl font-bold text-brand-petroleum tracking-tighter" data-id="element-127">
                {fmt(timeLeft.hours)}
              </span>
              <p className="text-[8px] text-brand-medium-grey font-bold uppercase tracking-[0.2em] mt-1.5" data-id="element-128">
                HS
              </p>
            </div>
            <span className="text-2xl font-bold text-brand-gold-warm/30 mb-5" data-id="element-129">
              :
            </span>
            <div className="text-center" data-id="element-130">
              <span className="text-3xl md:text-4xl font-bold text-brand-petroleum tracking-tighter" data-id="element-131">
                {fmt(timeLeft.minutes)}
              </span>
              <p className="text-[8px] text-brand-medium-grey font-bold uppercase tracking-[0.2em] mt-1.5" data-id="element-132">
                MIN
              </p>
            </div>
            <span className="text-2xl font-bold text-brand-gold-warm/30 mb-5" data-id="element-133">
              :
            </span>
            <div className="text-center" data-id="element-134">
              <span className="text-3xl md:text-4xl font-bold text-brand-petroleum tracking-tighter" data-id="element-135">
                {fmt(timeLeft.seconds)}
              </span>
              <p className="text-[8px] text-brand-medium-grey font-bold uppercase tracking-[0.2em] mt-1.5" data-id="element-136">
                SEG
              </p>
            </div>
          </div>
          <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-brand-terracotta bg-brand-soft-cream/50 inline-block px-4 py-1.5 rounded-full border border-brand-terracotta/10" data-id="element-137">
            El precio de lanzamiento termina pronto
          </p>
        </div>

        <div className="mb-6" data-id="element-138">
          <div className="text-4xl font-black text-brand-petroleum mb-4 tracking-tighter" data-id="element-139">
            $19.990 ARS
          </div>
          <a href={checkoutUrl} className="block w-full btn-premium py-4 px-4 md:px-8 rounded-[24px] transition-all hover:scale-[1.02] text-center no-underline text-base md:text-lg shadow-xl uppercase font-bold tracking-wide" data-id="element-140">
            ✨ QUIERO EL KIT TAROT LISTO
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-[10px] font-bold text-brand-medium-grey uppercase tracking-widest pt-6 border-t border-brand-petroleum/5" data-id="element-141">
          <div className="flex items-center gap-3" data-id="element-142">
            <Lock size={16} className="text-brand-sage-green" data-id="element-143" />
            <span data-id="element-144">Pago seguro</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-145">
            <Zap size={16} className="text-brand-sage-green" data-id="element-146" />
            <span data-id="element-147">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-148">
            <ShieldCheck size={16} className="text-brand-sage-green" data-id="element-149" />
            <span data-id="element-150">Garantía total</span>
          </div>
        </div>
      </div>
    </div>;
}